// extracted by mini-css-extract-plugin
module.exports = {"root":"styles_root__1XE3O","rootMobile":"styles_rootMobile__2em_U"};